import { render, staticRenderFns } from "./WordExamDialog.vue?vue&type=template&id=ad05ce9c&scoped=true&"
import script from "./WordExamDialog.vue?vue&type=script&lang=js&"
export * from "./WordExamDialog.vue?vue&type=script&lang=js&"
import style0 from "./WordExamDialog.vue?vue&type=style&index=0&id=ad05ce9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad05ce9c",
  null
  
)

component.options.__file = "WordExamDialog.vue"
export default component.exports